var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "_pickf",
      class: { _hov: this.hovered },
      style: { width: _vm.width, height: _vm.height },
      on: {
        dragenter: function($event) {
          $event.preventDefault()
          return _vm._dragenter($event)
        },
        dragleave: function($event) {
          $event.preventDefault()
          return _vm._dragleave($event)
        },
        dragover: function($event) {
          $event.preventDefault()
        },
        drop: function($event) {
          $event.preventDefault()
          return _vm._drop($event)
        }
      }
    },
    [
      _c(
        "input",
        _vm._g(
          {
            ref: "_in",
            staticClass: "_pickfi",
            attrs: {
              type: "file",
              "aria-hidden": "true",
              id: _vm.id,
              name: _vm.name,
              multiple: _vm.maxfiles != 1,
              accept: _vm._accept,
              capture: _vm.capture,
              inert: _vm.inert
            },
            on: { change: _vm._change }
          },
          _vm.__on
        )
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.ivalue || !_vm.ivalue.length,
              expression: "!ivalue || !ivalue.length"
            }
          ],
          staticClass: "_pickfp"
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 50 50"
              }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M20 8C13.54 8 8.37 13.1 8.1 19.5A10.92 10.92 0 0 0 0 30c0 6.05 4.95 11 11 11h30c4.95 0 9-4.05 9-9 0-3.9-2.6-7.2-6.1-8.38C43.7 17.77 38.92 13 33 13c-1.04 0-2 .26-2.97.53A12.05 12.05 0 0 0 20 8zm0 2c3.73 0 7 2.1 8.72 5.1l.44.71.78-.28A9.02 9.02 0 0 1 42 24v1.1l.78.18A6.95 6.95 0 0 1 48 32c0 3.86-3.14 7-7 7H11c-4.95 0-9-4.05-9-9 0-4.33 3.06-8 7.19-8.81l.81-.16V20c0-5.57 4.43-10 10-10zm5 8.6l-.72.68-6 6 1.44 1.44L24 22.44V34h2V22.44l4.28 4.28 1.44-1.44-6-6z"
                }
              })
            ]
          ),
          _c("div", [
            _vm._v(_vm._s(_vm._ph[0])),
            _vm._ph[2]
              ? _c(
                  "a",
                  _vm._g(
                    {
                      ref: "proxy",
                      attrs: { role: "button" },
                      domProps: { textContent: _vm._s(_vm._ph[1]) }
                    },
                    _vm.__fwd
                  )
                )
              : _vm._e(),
            _vm._v(_vm._s(_vm._ph[2] || _vm._ph[1]))
          ]),
          _vm.maxfiles || _vm.maxsize || _vm.maxtotal
            ? _c("div", { staticClass: "_pickfps fs8 fg50" }, [
                _vm.maxfiles
                  ? _c("span", {
                      staticClass: "_pickfpd",
                      domProps: { textContent: _vm._s(_vm.maxfilest) }
                    })
                  : _vm._e(),
                _vm.maxsize
                  ? _c("span", {
                      staticClass: "_pickfpd",
                      domProps: { textContent: _vm._s(_vm.maxsizet) }
                    })
                  : _vm._e(),
                _vm.maxtotal
                  ? _c("span", {
                      staticClass: "_pickfpd",
                      domProps: { textContent: _vm._s(_vm.maxtotalt) }
                    })
                  : _vm._e(),
                _vm.accept
                  ? _c("span", {
                      staticClass: "_pickfpd",
                      domProps: { textContent: _vm._s(_vm.acceptt) }
                    })
                  : _vm._e()
              ])
            : _vm._e()
        ]
      ),
      _c(
        "ul",
        { staticClass: "_pickfl" },
        [
          _vm._l(_vm.ivalue, function(f, i) {
            return _c(
              "li",
              [
                _vm.thumb[i]
                  ? _c("img", {
                      staticClass: "_pickft",
                      attrs: { src: _vm.thumb[i] },
                      on: {
                        error: function($event) {
                          return _vm.$set(_vm.thumb, i, null)
                        }
                      }
                    })
                  : _c("div", {
                      staticClass: "_pickft",
                      domProps: {
                        textContent: _vm._s(
                          (
                            (f.name.match(/\.([^.]*)$/) || [])[1] || "?"
                          ).toLowerCase()
                        )
                      }
                    }),
                _c("div", { staticClass: "_pickfd" }, [
                  _c("p", { staticClass: "text-bold" }, [
                    _vm._v(_vm._s(f.name))
                  ]),
                  _c("p", { staticClass: "fs7 fg50" }, [
                    _c("span", {
                      directives: [
                        {
                          name: "num",
                          rawName: "v-num.bytes",
                          value: f.size,
                          expression: "f.size",
                          modifiers: { bytes: true }
                        }
                      ]
                    }),
                    _vm.maxfiles && i >= _vm.maxfiles
                      ? _c("span", {
                          staticClass: "fg-error start-lg",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$locale.data.dropMaxFilesErr.replace(
                                "{n}",
                                _vm.$num.int(_vm.maxfiles)
                              )
                            )
                          }
                        })
                      : _vm._e(),
                    _vm.maxsize && f.size > _vm.maxsize
                      ? _c("span", {
                          staticClass: "fg-error start-lg",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$locale.data.dropMaxSizeErr.replace(
                                "{n}",
                                _vm.$num.bytes(_vm.maxsize)
                              )
                            )
                          }
                        })
                      : _vm._e(),
                    _vm.accept && !_vm.accept.includes(f.type)
                      ? _c("span", {
                          staticClass: "fg-error start-lg",
                          domProps: {
                            textContent: _vm._s(_vm.$locale.data.dropAcceptErr)
                          }
                        })
                      : _vm._e()
                  ])
                ]),
                _c(
                  "ib-button",
                  {
                    staticClass: "_pickfb link fs5 fg50",
                    on: {
                      click: function($event) {
                        return _vm._delete(i)
                      }
                    }
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 50 50"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M25 3C12.87 3 3 12.87 3 25s9.87 22 22 22 22-9.87 22-22S37.13 3 25 3zm8.71 29.29a1 1 0 0 1 0 1.42c-.2.19-.45.29-.71.29s-.51-.1-.71-.29L25 26.42l-7.29 7.29c-.2.19-.45.29-.71.29s-.51-.1-.71-.29a1 1 0 0 1 0-1.42L23.58 25l-7.29-7.29a1 1 0 0 1 0-1.42 1 1 0 0 1 1.42 0L25 23.58l7.29-7.29a1 1 0 0 1 1.42 0 1 1 0 0 1 0 1.42L26.42 25l7.29 7.29z"
                          }
                        })
                      ]
                    )
                  ]
                )
              ],
              1
            )
          }),
          _vm.ivalue &&
          _vm.ivalue.length &&
          (!_vm.maxfiles || _vm.ivalue.length < _vm.maxfiles)
            ? _c("li", [
                _c("div", { staticClass: "_pickft bg10-accent fg-accent" }, [
                  _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                    _c("path", {
                      attrs: { d: "M24 10H14V0h-4v10H0v4h10v10h4V14h10z" }
                    })
                  ])
                ]),
                _c("div", { staticClass: "_pickfd text-bold" }, [
                  _c("a", {
                    attrs: { role: "button" },
                    domProps: { textContent: _vm._s(_vm.$locale.data.dropAdd) },
                    on: { click: _vm.__fwdclick }
                  })
                ])
              ])
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }